export default "__VITE_ASSET__1946ca09__"